// Kontrol tampilan reusable: ganti tema (light/dark/hc) + toggle cepat
// A-/A+ skala teks (US-SET-3). Dipakai di Topbar (sheet) & Pengaturan.

import { Contrast, Moon, Sun, type LucideIcon } from "lucide-react";
import { Button } from "@ds/ui";
import { cn } from "@ds/lib/utils";
import { useTheme, type Theme } from "../../lib/theme";

const themeIcon: Record<Theme, LucideIcon> = { light: Sun, dark: Moon, hc: Contrast };

export function AppearanceControls({ block = false }: { block?: boolean }) {
  const { theme, themeLabel, scale, cycleTheme, incScale, decScale } = useTheme();
  const Icon = themeIcon[theme];

  return (
    <div className={cn("flex items-center gap-2", block && "w-full")}>
      <Button
        variant="secondary"
        className={cn(block && "flex-1")}
        onClick={cycleTheme}
      >
        <Icon className="size-4" aria-hidden />
        {themeLabel}
      </Button>
      <Button variant="secondary" size="icon" onClick={decScale} aria-label="Perkecil teks">
        A−
      </Button>
      <span className="w-10 text-center text-xs tabular-nums text-muted">
        {Math.round(scale * 100)}%
      </span>
      <Button variant="secondary" size="icon" onClick={incScale} aria-label="Perbesar teks">
        A+
      </Button>
    </div>
  );
}
